<template>
    <!-- 头部图片 -->
    <!-- <section class="slice py-7"> -->
    <div class="homecontainer container-fluid no-gutters w-container">
        <div class="row row-grid align-items-center">
            <div class="text-center">
                <!-- Image -->
                <figure class="w-100">
                    <img alt="Image placeholder" src="../assets/img/created/img-top.jpg" class="img-fluid">
                </figure>
            </div>
        </div>

        <!-- </section> -->
        <div>
            <div class="row mb-5 justify-content-center text-center">
                <div class="col-lg-6">
                    <h2 class=" mt-4">园区文创</h2>
                </div>
            </div>
            <!-- Card -->
            <div class="row justify-content-center mt-5 ">
                <div class="col-md-12" style="max-width: 1400px;">
                    <div class="row pb-3 justify-content-center" v-for="(item, index) in shopList" :key="index" @click="clickBtn(item)">
                        <div class="pt-4 pb-3 ">
                            <!-- <img src="../assets/img/created/list-1.jpg" class="img-fluid img-center" style="height: 150px;" alt="Illustration" /> -->
                            <img :src="item.img" class="img-fluid img-center" style="height: 150px;"
                                alt="Illustration" />
                        </div>
                        <div class="col-8 col-md-8 pt-4 pb-3">
                            <h5 class="h4 lh-130 mb-3">{{ item.name }} 一一 <span class="small text-muted">{{item.typeJade}}</span></h5>
                            <p class="text-muted mb-0">
                                <span v-html="item.desc"></span>
                                <!-- {{ item.desc }} -->
                            </p>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Created',
    data() {
        return {
            shopList: [
                {
                    id: '202221212',
                    name: '十二生肖',
                    typeJade: '（青玉/墨玉款）',
                    desc: '以图腾表意，传达中华民族的生命哲学，讲述中国人的精神力量，展现着民族气韵与深厚文化精粹。<br/>青玉，历经漫长时间而形成，化不开的浓郁青色，自带一种深邃的时间苍茫感。温润、刚劲，寓意基业长青。正国雕刻着属相的甲骨文，是中国文字的开端，背面是相应的栩栩如生的生肖的图形。诠释着中华民族的生命哲学两两相对，寓意深刻，是祖先对我们的期望和要求传承的是高尚品质和精神。<br\>',  //我们从一出生便会与一个生肖伴随一生，是我们来到世界上的第一份文化祝福是“天选之物”。十二生肖的每一个字都是缩影，雕琢之味伸是灵魂画师。是十几亿中国人的精神绘归。
                    img: 'https://si.geilicdn.com/pcdecorate1634419872-06640000018a2b4b89220a22d3fa-unadjust_750_750.png.webp?w=750&h=750&cp=1',
                    url: 'https://shop1806221546.v.weidian.com/item.html?itemID=6568919393',
                    
                },
                {
                    id: '202221213',
                    name: '吉祥三宝',
                    typeJade: '大（金/银款）',
                    desc: '玉是山川的精华，上天恩赐的宝物，具有沟通天、地、神的灵性。<br>玉瑛、玉环、玉壁三玉相叠。色碧茶白.深然无暇。圆融通透，盈缺有度。在和田玉的万种颜色中，选用了“脂白”“石青”“黛绿”这三种中国传统色，极具代表性，是注入国人基因中底色，是纯正的“国色”。作品中间的玉环，因“环”与“还”同音，有应允和盼望归来的意思，古人把它作为一种信物一一见“环”即“还”。有着“盼归、团圆”的寓意，在作品中也预示着传统文化的“归来”。', //作品将玉璧、玉环、玉瑷这三种最为传统的形制有机的结合在了一起，也蕴含将这中间的三个“好”费穿起来，因此我们的设计团队又叫它：“吉祥三宝”，期待着这件饰品能给佩戴者带来吉祥。
                    img: 'https://si.geilicdn.com/pcdecorate1634419872-6abb0000018a2a953a9e0a23034c_3125_4167.jpg.webp?w=750&h=750&cp=1',
                    url: 'https://shop1806221546.v.weidian.com/item.html?itemID=4540504992',

                },
                {
                    id: '202221214',
                    name: '吉祥三宝',
                    typeJade: '小（金/银款）',
                    desc: '玉是山川的精华，上天恩赐的宝物，具有沟通天、地、神的灵性。<br>玉瑛、玉环、玉壁三玉相叠。色碧茶白.深然无暇。圆融通透，盈缺有度。在和田玉的万种颜色中，选用了“脂白”“石青”“黛绿”这三种中国传统色，极具代表性，是注入国人基因中底色，是纯正的“国色”。作品中间的玉环，因“环”与“还”同音，有应允和盼望归来的意思，古人把它作为一种信物一一见“环”即“还”。有着“盼归、团圆”的寓意，在作品中也预示着传统文化的“归来”。', //作品将玉璧、玉环、玉瑷这三种最为传统的形制有机的结合在了一起，也蕴含将这中间的三个“好”费穿起来，因此我们的设计团队又叫它：“吉祥三宝”，期待着这件饰品能给佩戴者带来吉祥。
                    img: 'https://si.geilicdn.com/pcdecorate1634419872-6ab40000018a2a945ca30a2313a2_3125_4167.jpg.webp?w=750&h=750&cp=1',
                    url: 'https://shop1806221546.v.weidian.com/item.html?itemID=7212764237&spider_token=61d4',

                },
            ]
        }
    },
    methods:{
        clickBtn(item){
            console.log(item);
            // this.$router.push(item.url)
            window.open(item.url, '_blank');
            // this.$router.push({
            //     name:'newsDetail',
            //     query:{
            //         path:item.url
            //     }
            // })
        }
    },
}
</script>

<style lang="less" scoped>
.w-container {
    background-color: #fff;
    /* relative(相对定位) */
}

.py-7 {
    /* 若根元素 font-size 为 12px, 2rem;  2 × 12px = 24px */
    padding-top: 6rem !important;
}

.img-center {
    display: block;

    margin-right: auto;
    margin-left: auto;
}
</style>